import React, { useEffect } from 'react';
import './App.css';

// Helper Component
const PolicyWrapper = ({ title, children }) => {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="policy-page">
      <div className="policy-container">
        <h1 className="policy-title">{title}</h1>
        <div className="policy-content">
          {children}
        </div>
      </div>
    </div>
  );
};

// 1. RETURN & EXCHANGE POLICY (Matches your Image)
export const ReturnExchange = () => (
  <PolicyWrapper title="RETURN & EXCHANGE POLICY">
    <p>At <strong>Antarvaani</strong>, we are committed to delivering premium quality products. If something isn't right, we're here to help.</p>
    <hr className="policy-divider" />

    <h3>7-Day Return Policy</h3>
    <p>Customers can request a <strong>return or exchange within 7 days</strong> of receiving their order.</p>
    <p>To be eligible:</p>
    <ul>
      <li>Item must be <strong>unused, unworn, and unwashed</strong>.</li>
      <li>All <strong>original tags and packaging</strong> must be intact.</li>
      <li>An <strong>unboxing video</strong> is required as proof in case of damage or wrong item.</li>
    </ul>
    <hr className="policy-divider" />

    <h3>Non-Returnable Items</h3>
    <p>Returns or exchanges will <strong>not</strong> be accepted for:</p>
    <ul>
      <li>Items purchased during <strong>sale or discount offers</strong>.</li>
      <li>Products damaged due to <strong>improper use or handling</strong>.</li>
      <li>Requests made <strong>after 7 days</strong> of delivery.</li>
    </ul>
    <hr className="policy-divider" />

    <h3>Damaged / Wrong Product</h3>
    <p>If you receive a damaged, defective, or incorrect item:</p>
    <ul>
      <li>Email us within <strong>48 hours of delivery</strong> at <strong>contact@antarvaani.com</strong>.</li>
      <li>Share an <strong>unboxing video and clear images</strong> of the issue.</li>
    </ul>
    <p>Our team will verify and arrange a replacement or refund.</p>
    <hr className="policy-divider" />

    <h3>Exchange Policy</h3>
    <p>We offer exchanges for:</p>
    <ul>
      <li><strong>Size issues</strong></li>
      <li><strong>Manufacturing defects</strong></li>
    </ul>
    <p>Once the returned product passes quality check, we will dispatch the replacement item.</p>
    <hr className="policy-divider" />

    <h3>Refund Policy</h3>
    <p>After we receive and inspect the returned item:</p>
    <ul>
      <li>Refunds will be processed within <strong>5-7 working days</strong>.</li>
      <li>The amount will be credited to the customer's <strong>bank account or original UPI payment method</strong>.</li>
      <li>No store credit is issued.</li>
    </ul>
    <hr className="policy-divider" />

    <h3>Return Shipping</h3>
    <ul>
      <li>If the return is due to a <strong>defect or wrong product</strong>, we cover the shipping cost.</li>
      <li>For <strong>size exchanges</strong>, customers may be required to bear return shipping charges.</li>
    </ul>
    <hr className="policy-divider" />

    <h3>How to Request a Return or Exchange</h3>
    <p>Email us at <strong>contact@antarvaani.com</strong> with:</p>
    <ul>
      <li>Order ID</li>
      <li>Reason for return/exchange</li>
      <li>Unboxing video (mandatory for damage claims)</li>
    </ul>
    <p>Our support team will guide you through the next steps.</p>
    <p><strong>Antarvaani reserves the right to refuse returns that do not meet our policy conditions.</strong></p>
  </PolicyWrapper>
);

// 2. SHIPPING POLICY
export const ShippingPolicy = () => (
  <PolicyWrapper title="SHIPPING POLICY">
    <p>Thank you for shopping with Antarvaani. We are committed to delivering your order quickly, safely, and smoothly. Below are the details of how our shipping process works.</p>
    <hr className="policy-divider" />

    <h3>Order Processing & Dispatch</h3>
    <p>All orders are <strong>processed and dispatched within 24 hours</strong> of order confirmation.</p>
    <p>Orders are dispatched on working days (Monday-Saturday, excluding public holidays). During peak sales or promotional periods, slight delays may occur, but we always aim to ship as quickly as possible.</p>
    <hr className="policy-divider" />

    <h3>Delivery Time</h3>
    <p>Delivery timelines vary based on your location:</p>
    <ul>
      <li><strong>Metro Cities:</strong> 3-5 working days</li>
      <li><strong>Other Cities & Towns:</strong> 5-9 working days</li>
    </ul>
    <p>Please note that delivery timelines are estimates and may vary due to factors beyond our control, such as weather conditions, courier delays, or regional restrictions.</p>
    <hr className="policy-divider" />

    <h3>Order Tracking</h3>
    <p>As soon as your order is shipped, you will receive a<strong> Tracking ID via SMS or Email.</strong> You can use this Tracking ID on our<strong> Track Order</strong> page to check real-time updates on your shipment.</p>
    <p>If you do not see the tracking email in your inbox, please check your <strong>Spam or Junk folder,</strong> as emails may sometimes be filtered there </p>
    <p> If you still do not receive tracking details within <strong>48 hours of placing your order,</strong> please contact us and we will assist you.</p>
    <hr className="policy-divider" />
  <h3> Shipping Coverage
    </h3>
    <p>We currently ship across india.Delivery availibility may vary for remote or restricted areas depending on courier serviceability</p>
<hr className="policy-divider" />
    <h3>Incorrect Address / Delivery Issues</h3>
    <p>Please ensure your shipping address and contact details are accurate while placing the order. Antarvaani is not responsible for delays or failed deliveries due to incorrect information provided by the customer.</p>
    <p>If a package is returned to us due to address issues, additional shipping charges may apply for re-dispatch.</p>
<hr className="policy-divider" />
<h3>Damaged or Missing Items</h3>
<p>If you recieved a damaged package or an item is missing from your order,please contact us within 48 hours of delivery with photos and your order details so we can resolve the issue quickly</p>
<hr className="policy-divider" />
<h3> Neep Help ?</h3>
<p> If you have  any questions abouut shipping or delivery feel free to contact us </p>
<ul>
  <li> Mail : contact@antarvaani.com</li>
  <li> Phone : +91 9310683989</li>
</ul>
<p> We're always here to help</p>
    
  </PolicyWrapper>
);

// 3. TERMS & CONDITIONS (UPDATED & COMPLETE)
export const TermsConditions = () => (
  <PolicyWrapper title="TERMS & CONDITIONS">
    <p>Welcome to <strong>Antarvaani</strong>. By accessing our website and purchasing from us, you agree to the following Terms & Conditions. Please read them carefully before using our services.</p>
    <hr className="policy-divider" />

    <h3>1. General</h3>
    <p>By using this website, you confirm that you are at least <strong>18 years old</strong> or are using the website under the supervision of a parent or guardian.</p>
    <p>Antarvaani reserves the right to update, change, or replace any part of these Terms & Conditions at any time without prior notice.</p>
    <hr className="policy-divider" />

    <h3>2. Product Information</h3>
    <p>We strive to display product colors, designs, and details as accurately as possible. However, slight variations may occur due to:</p>
    <ul>
      <li>Screen display differences</li>
      <li>Lighting in product photography</li>
      <li>Fabric dye variations</li>
    </ul>
    <p>These minor differences do not qualify as defects.</p>
    <hr className="policy-divider" />

    <h3>3. Pricing & Payments</h3>
    <p>All prices listed on the website are in <strong>INR (₹)</strong> and inclusive/exclusive of taxes as mentioned.</p>
    <p>We reserve the right to:</p>
    <ul>
      <li>Modify prices at any time without prior notice</li>
      <li>Cancel orders in case of pricing errors</li>
    </ul>
    <p>Payments must be completed through the available secure payment methods at checkout.</p>
    <hr className="policy-divider" />

    <h3>4. Order Acceptance</h3>
    <p>Once an order is placed, you will receive an order confirmation. This <strong>does not guarantee</strong> acceptance of your order.</p>
    <p>Antarvaani reserves the right to cancel or refuse any order due to:</p>
    <ul>
      <li>Product unavailability</li>
      <li>Payment issues</li>
      <li>Suspected fraudulent activity</li>
    </ul>
    <p>If your order is canceled after payment, a full refund will be issued.</p>
    <hr className="policy-divider" />

    <h3>5. Shipping</h3>
    <p>All shipping timelines and processes are governed by our <strong>Shipping Policy</strong>. Delivery delays caused by courier partners or external factors are beyond our control.</p>
    <hr className="policy-divider" />

    <h3>6. Returns, Exchanges & Refunds</h3>
    <p>All return, exchange, and refund requests are handled according to our <strong>Return & Exchange Policy</strong>. By placing an order, you agree to those terms.</p>
    <hr className="policy-divider" />

    <h3>7. Intellectual Property</h3>
    <p>All content on this website — including logos, designs, images, graphics, text, and branding — is the property of <strong>Antarvaani</strong> and is protected by intellectual property laws.</p>
    <p>You may not copy, reproduce, or use any content without written permission from us.</p>
    <hr className="policy-divider" />

    <h3>8. User Conduct</h3>
    <p>While using our website, you agree not to:</p>
    <ul>
      <li>Use the site for unlawful purposes</li>
      <li>Attempt to hack, damage, or disrupt the website</li>
      <li>Provide false or misleading information</li>
    </ul>
    <p>Violation of these terms may result in restricted access or legal action.</p>
    <hr className="policy-divider" />

    <h3>9. Limitation of Liability</h3>
    <p>Antarvaani shall not be held liable for any indirect, incidental, or consequential damages arising from:</p>
    <ul>
      <li>Use of our products</li>
      <li>Delay in delivery</li>
      <li>Website interruptions</li>
    </ul>
    <p>Our maximum liability shall not exceed the value of the product purchased.</p>
    <hr className="policy-divider" />

    <h3>10. Governing Law</h3>
    <p>These Terms & Conditions shall be governed by and interpreted in accordance with the laws of <strong>India</strong>. Any disputes shall be subject to the jurisdiction of the courts in <strong>India</strong>.</p>
    <hr className="policy-divider" />

    <h3>11. Contact Information</h3>
    <p>For any questions regarding these Terms & Conditions, please contact us:</p>
    <p>📧 <strong>contact@antarvaani.com</strong></p>
  </PolicyWrapper>
);

// 4. REFUND POLICY (UPDATED & COMPLETE)
export const RefundPolicy = () => (
  <PolicyWrapper title="REFUND POLICY">
    <p>At <strong>Antarvaani</strong>, customer satisfaction is important to us. This Refund Policy explains when and how refunds are processed for eligible orders.</p>
    <p>Please read this policy carefully before making a purchase.</p>
    <hr className="policy-divider" />

    <h3>1. Eligibility for Refund</h3>
    <p>Refunds are applicable only in the following cases:</p>
    <ul>
      <li>You received a <strong>damaged product</strong></li>
      <li>You received the <strong>wrong item</strong></li>
    </ul>
    <p>All refund requests must be raised within <strong>48 hours of delivery</strong>.</p>
    <hr className="policy-divider" />

    <h3>2. Mandatory Proof</h3>
    <p>To be eligible for a refund, you must provide:</p>
    <ul>
      <li>A clear <strong>unboxing video</strong> showing the package being opened</li>
      <li>Clear <strong>images of the issue</strong> (damage or wrong product)</li>
      <li>Order ID and registered contact details</li>
    </ul>
    <p>Without proper unboxing proof, we may not be able to process the refund.</p>
    <hr className="policy-divider" />

    <h3>3. Product Condition</h3>
    <p>The product must be:</p>
    <ul>
        <li><strong>Unused and unwashed</strong></li>
        <li>In <strong>original condition and packaging</strong></li>
        <li>With all <strong>tags and labels intact</strong></li>
    </ul>
    <p>Products that show signs of use or damage caused after delivery will not be eligible.</p>
    <hr className="policy-divider" />

    <h3>4. Refund Process</h3>
    <p>Once your request is reviewed and approved:</p>
    <ol style={{paddingLeft: '20px', marginBottom: '15px'}}>
        <li>Our team may arrange a <strong>reverse pickup</strong> of the product.</li>
        <li>After the returned item passes quality inspection, the refund will be initiated.</li>
    </ol>
    <p>Refunds will be processed to:</p>
    <ul>
        <li>The <strong>original bank account</strong>, or</li>
        <li>The <strong>UPI ID/number</strong> shared by the customer</li>
    </ul>
    <p>Refund processing usually takes <strong>5–7 working days</strong> after approval.</p>
    <hr className="policy-divider" />

    <h3>5. Non-Refundable Situations</h3>
    <p>Refunds will not be provided in the following cases:</p>
    <ul>
        <li>Size issues (exchange only, if applicable)</li>
        <li>Minor color variations due to screen differences</li>
        <li>Requests made after 48 hours of delivery</li>
        <li>Products returned without original packaging</li>
        <li>Lack of required proof (unboxing video)</li>
    </ul>
    <hr className="policy-divider" />

    <h3>6. Shipping Charges</h3>
    <p>Original shipping charges (if any) are <strong>non-refundable</strong>, unless the error was from our side (wrong or damaged product sent).</p>
    <hr className="policy-divider" />

    <h3>7. Contact for Refund Requests</h3>
    <p>To request a refund, contact us with complete details:</p>
    <p>📧 <strong>contact@antarvaani.com</strong></p>
    <p>📱 <strong>+91 93106 83989</strong></p>
    <p>Please include:</p>
    <ul>
        <li>Order ID</li>
        <li>Unboxing video</li>
        <li>Images of the issue</li>
        <li>Bank details or UPI ID (for refund processing)</li>
    </ul>
    <p>Our team will respond within <strong>24–48 working hours</strong>.</p>
    <hr className="policy-divider" />

    <p>Antarvaani maintains strict quality standards to ensure you receive the best. We appreciate your cooperation in following the above process.</p>
  </PolicyWrapper>
);

// 5. CONTACT US
export const ContactUsPage = () => (
  <PolicyWrapper title="CONTACT US">
    <p>We're here to help. Whether you have a question about your order, sizing, exchanges, or just want to know more about Antarvaani, our team is always happy to assist you.</p>
    <hr className="policy-divider" />

    <div style={{padding: '20px', background: '#f8f8f8', borderRadius: '8px', border: '1px solid #eee'}}>
      <h3>Customer Support</h3>
      <p><strong>Email:</strong> contact@antarvaani.com</p>
      <p><strong>Phone/WhatsApp:</strong> +91 93106 83989</p>
      <p style={{fontSize: '0.9rem', color: '#666'}}>Our support team typically responds within<strong> 24-48 working hours</strong> (Monday-Saturday).</p>
    </div>
    <hr className="policy-divider" />

    <h3>Order & Support Queries</h3>
    <p> Please reach out to us for :</p>
    <ul>
      <li>Order tracking assistance</li>
      <li>Size and fit guidance</li>
      <li>Exchange & return support</li>
      <li>General brand  or collaboration inquiries</li>
    </ul>
    <p> When contacting us about an order ,kindli include your <strong>Order ID</strong> for faster assistance</p>
<hr className="policy-divider" />
<h3>Business & Collaboration</h3>
<p>For partnerShips,collaboration,or business inqueries,please email us with full details at </p>
<p> 📧 contact@antarvaani.com</p>
  </PolicyWrapper>
);

// 6. ABOUT US (UPDATED & COMPLETE)
export const AboutUs = () => (
  <PolicyWrapper title="ABOUT US">
    <p><strong>Antarvaani was created from a simple belief — what you wear should feel like it belongs to you.</strong></p>
    
    <p>In a world full of fast fashion and loud trends, Antarvaani stands for something quieter, deeper, and more personal. We believe clothing should not just fit your body, but reflect your presence, your confidence, and your inner voice.</p>
    
    <p>Founded in <strong>2025</strong> and proudly <strong>Made in India</strong>, Antarvaani was built with a vision to make premium, unisex streetwear that feels as good as it looks. Every piece is designed with intention — from fabric selection to fit and finish — to create everyday essentials that carry a sense of understated strength.</p>
    <hr className="policy-divider" />

    <h3>Our Philosophy</h3>
    <p>We don't believe in overdesigning. We believe in <strong>refinement</strong>.</p>
    <p>Antarvaani focuses on:</p>
    <ul>
      <li>Clean, timeless silhouettes</li>
      <li>Premium heavyweight fabrics</li>
      <li>Comfort that lasts all day</li>
      <li>Minimal designs with maximum presence</li>
    </ul>
    <p>Because true style doesn't need to be loud — it just needs to feel right.</p>
    <hr className="policy-divider" />

    <h3>More Than Just Streetwear</h3>
    <p>Antarvaani is for those who move with quiet confidence.</p>
    <p>For those who prefer presence over noise.</p>
    <p>For those who know that comfort is not basic — it's powerful.</p>
    <p>Our clothing is made to become part of your everyday life — easy to wear, hard to ignore.</p>
    <hr className="policy-divider" />

    <h3>The Meaning of Antarvaani</h3>
    <p>“Antarvaani” means <strong>the voice within</strong>.</p>
    <p>It represents self-expression without pressure and confidence without performance.</p>
    <p>When you wear Antarvaani, you're not trying to be someone else. You're simply becoming more of who you already are.</p>
    <hr className="policy-divider" />

    <p style={{ fontSize: '1.1rem' }}><strong>Antarvaani — wear your inner voice.</strong></p>
  </PolicyWrapper>
);

// 7. PRIVACY POLICY (UPDATED & COMPLETE)
export const PrivacyPolicy = () => (
  <PolicyWrapper title="PRIVACY POLICY">
    <p>At <strong>Antarvaani</strong>, your privacy is extremely important to us. This Privacy Policy explains how we collect, use, and protect your personal information when you visit our website or make a purchase.</p>
    <p>By using our website, you agree to the practices described below.</p>
    <hr className="policy-divider" />
    
    <h3>1. Information We Collect</h3>
    <p>When you use our website, we may collect the following information:</p>
    <p><strong>Personal Information</strong></p>
    <ul>
      <li>Name</li>
      <li>Phone number</li>
      <li>Email address</li>
      <li>Shipping & billing address</li>
      <li>Payment details (processed securely via payment gateways)</li>
    </ul>
    <p><strong>Non-Personal Information</strong></p>
    <ul>
      <li>Browser type</li>
      <li>Device information</li>
      <li>IP address</li>
      <li>Pages visited and time spent on our website</li>
    </ul>
    <p>This helps us improve your shopping experience.</p>
    <hr className="policy-divider" />

    <h3>2. How We Use Your Information</h3>
    <p>Your information is used to:</p>
    <ul>
      <li>Process and deliver your orders</li>
      <li>Send order confirmations and tracking updates</li>
      <li>Provide customer support</li>
      <li>Improve our website and services</li>
      <li>Inform you about new drops, offers, or updates (only if you opt in)</li>
    </ul>
    <p>We do <strong>not</strong> sell or rent your personal information to third parties.</p>
    <hr className="policy-divider" />

    <h3>3. Payment Security</h3>
    <p>All payments on Antarvaani are processed through <strong>secure and trusted payment gateways</strong>. We do not store your card or banking details on our servers.</p>
    <hr className="policy-divider" />

    <h3>4. Sharing of Information</h3>
    <p>We may share necessary information only with:</p>
    <ul>
      <li>Courier partners (for order delivery)</li>
      <li>Payment providers (to process transactions)</li>
      <li>Service providers helping us operate our business</li>
    </ul>
    <p>These partners are obligated to keep your information secure and confidential.</p>
    <hr className="policy-divider" />

    <h3>5. Cookies</h3>
    <p>Our website may use <strong>cookies</strong> to enhance your browsing experience. Cookies help us:</p>
    <ul>
      <li>Remember your preferences</li>
      <li>Understand website traffic</li>
      <li>Improve performance</li>
    </ul>
    <p>You can disable cookies in your browser settings if you prefer.</p>
    <hr className="policy-divider" />

    <h3>6. Data Protection</h3>
    <p>We take reasonable security measures to protect your personal information from unauthorized access, misuse, or disclosure.</p>
    <p>However, no online transmission is 100% secure, and we cannot guarantee absolute security.</p>
    <hr className="policy-divider" />

    <h3>7. Your Rights</h3>
    <p>You have the right to:</p>
    <ul>
      <li>Request access to your personal data</li>
      <li>Ask for corrections to inaccurate information</li>
      <li>Request deletion of your data (where legally applicable)</li>
    </ul>
    <p>To make such requests, please contact us using the email below.</p>
    <hr className="policy-divider" />

    <h3>8. Third-Party Links</h3>
    <p>Our website may contain links to third-party websites. Antarvaani is not responsible for the privacy practices or content of those sites.</p>
    <hr className="policy-divider" />

    <h3>9. Policy Updates</h3>
    <p>We may update this Privacy Policy from time to time. Changes will be posted on this page, and continued use of the website means you accept those updates.</p>
    <hr className="policy-divider" />

    <h3>10. Contact Us</h3>
    <p>If you have any questions about this Privacy Policy or how your data is handled, please contact us:</p>
    <p>📧 <strong>contact@antarvaani.com</strong></p>
  </PolicyWrapper>
);

// 8. OUR STORY
export const OurStory = () => (
  <PolicyWrapper title="OUR STORY">
    <div style={{textAlign: 'center', marginBottom: '40px'}}>
      <h2 style={{fontSize: '2.5rem', marginBottom: '5px', letterSpacing: '2px'}}>ANTARVAANI</h2>
      <p style={{fontStyle: 'italic', color: '#666', fontSize: '1.1rem'}}>Wear Your Inner Voice</p>
    </div>
    <hr className="policy-divider" />
    
    <p>Founded in 2025 by <strong>Vikas Gupta</strong>, Antarvaani was born from a simple yet powerful belief — clothes shouldn't just be worn, they should be felt.</p>
    
    <p>The word <strong>Antarvaani</strong> means  <strong>"the voice within"</strong> — your thoughts, dreams, emotions, and attitude that make you who you are. In a world full of noise, fast trends, and copies, Antarvaani stands for<strong> real self-expression without filters.</strong></p>

    <p>This brand didn't begin in a corporate boardroom. It started with a vision to create a <strong>Made in India streetwear label </strong>that speaks to a generation that is bold, self-aware, and unapologetically original.</p>

    <p>Vikas Gupta believed fashion should do more than just look good. It should represent<strong>identity, mindset, and confidence</strong> . That's why Antarvaani is made for those who think differently, walk their own path, and express through style, not just words.</p>
<p>Every dropblends<strong> comfort, culture, and character</strong> — premiumfabrics, statement designs, and
silhouettes that feel as strong as the mindset behind them</p>
    <p>Antarvaani is not fast fashion. It is thoughtful, purpose-driven streetwear made in India. It's not about chasing trends. It's about wearing your inner voice on the outside.</p>
<p>It’s not about chasing trends.
It’s about wearing your inner voice on theoutside.</p>
<p>Fromgraphics that speak emotions</p>
<p>to fits that match your energy —</p>
<p>Antarvaani is for people who don’t just wear outfits…</p>
<p><strong>theywearattitude.</strong></p>
<p>This is morethan clothing.</p>
<p>This is<strong> identity stitched into fabric.</strong></p>
    <p style={{textAlign: 'center', marginTop: '40px', fontWeight: 'bold', fontSize: '1.2rem', letterSpacing: '1px'}}>Antarvaani - Speak without saying a word.</p>
  </PolicyWrapper>
);